// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"09aa4343","455":"b1667e11","977":"518eecde"}[chunkId] + ".chunk.js";
};